function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 512,
  height: 512
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo512"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle",
  fill: "#EE3442",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.369895,512 L155.369895,419.718298 C155.369895,417.336764 155.905425,413.764463 156.976485,409.001395 C158.047546,404.238328 160.189667,399.47526 163.402849,394.712193 C166.61603,389.949125 171.257293,385.721902 177.326636,382.030525 C183.395979,378.339148 191.428933,376.493459 201.425498,376.493459 C204.757686,376.493459 208.149378,376.791151 211.600573,377.386534 C215.051768,377.981918 218.562467,378.755916 222.132669,379.70853 L222.132669,338.269841 C219.514521,337.555381 216.955876,336.959998 214.456735,336.483691 C211.957594,336.007384 209.398949,335.769231 206.780801,335.769231 C195.356155,335.769231 185.240583,338.507995 176.434085,343.985522 C167.627587,349.46305 160.844204,357.203035 156.083935,367.205477 L155.369895,367.205477 L155.369895,340.055992 L112.527473,340.055992 L112.527473,512 L155.369895,512 Z M360.115249,512 C366.766761,510.003366 371.707447,508.321408 374.937307,506.954125 C387.314007,501.714751 398.500639,492.903076 408.497204,480.5191 L377.793469,457.299145 C372.319159,463.96744 365.952299,469.504506 358.692889,473.910344 C351.433478,478.316181 342.44847,480.5191 331.737865,480.5191 C319.599179,480.5191 309.245593,476.946799 300.677109,469.802198 C292.108625,462.657596 287.110342,452.655154 285.682261,439.794872 L416.351648,439.794872 L416.351648,428.006279 C416.351648,413.002616 414.388037,399.725565 410.460815,388.175126 C406.533593,376.624687 401.059284,366.919937 394.037887,359.060876 C387.01649,351.201814 378.567012,345.188441 368.689454,341.020757 C358.811896,336.853073 347.92278,334.769231 336.022107,334.769231 C323.169381,334.769231 311.030694,336.912611 299.606048,341.199372 C288.181403,345.486133 278.303844,351.559044 269.973373,359.418106 C261.642902,367.277167 255.038029,376.743764 250.158753,387.817896 C245.279477,398.892029 242.839839,411.216466 242.839839,424.791209 C242.839839,438.365952 245.279477,450.690389 250.158753,461.764521 C255.038029,472.838653 261.642902,482.30525 269.973373,490.164312 C278.303844,498.023373 288.181403,504.096285 299.606048,508.383046 C302.156506,509.340029 306.057539,510.545681 311.309148,512 L360.115249,512 Z M373.509226,407.644165 L285.682261,407.644165 C287.348356,395.26019 291.930115,385.376824 299.427538,377.994069 C306.924962,370.611315 317.100037,366.919937 329.952764,366.919937 C343.519531,366.919937 354.11113,370.551776 361.72756,377.815454 C369.343991,385.079133 373.271213,395.022036 373.509226,407.644165 L373.509226,407.644165 Z",
  id: "re",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo512") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca196995.svg";
export { ForwardRef as ReactComponent };